import { type ReactNode } from 'react'
import { Link } from '@muse-web/router'

import { IMAGE_RESIZE_SPEC } from '@core/image'
import { Cover } from '@ds/components'

import styles from './CollectionTileCard.module.css'

const COVER_SIZES = '(max-width: 767px) 60px, (max-width: 1023px) 152px, 164px'

export type TCollectionTileCardProps = {
    collectionId: string
    coverSrc: string
    coverAlt: string
    title: string
    titleHref: string
    authorLabel: string
    authorHref: string
    playSlot?: ReactNode
    onCardClick?: () => void
}

export const CollectionTileCard = ({
    collectionId,
    coverSrc,
    coverAlt,
    title,
    titleHref,
    authorLabel,
    authorHref,
    playSlot,
    onCardClick,
}: TCollectionTileCardProps) => (
    <div data-test-collection-id={`collection-card-${collectionId}`} className={styles.card}>
        <Link
            href={titleHref}
            aria-label={title}
            className={styles.overlay}
            onClick={onCardClick}
        />

        <div className={styles.coverBox}>
            <Cover
                stacked
                src={coverSrc}
                alt={coverAlt}
                sizes={COVER_SIZES}
                className={styles.coverImage}
                resize={IMAGE_RESIZE_SPEC}
            />
            {playSlot ? <div className={styles.coverPlay}>{playSlot}</div> : null}
        </div>

        <div className={styles.main}>
            <p className={styles.title}>{title}</p>
            <Link href={authorHref} className={styles.author}>
                {authorLabel}
            </Link>
        </div>
    </div>
)
